"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "setVirtualParent", {
    enumerable: true,
    get: function() {
        return setVirtualParent;
    }
});
function setVirtualParent(child, parent) {
    if (!child) {
        return;
    }
    const virtualChild = child;
    if (!virtualChild._virtual) {
        virtualChild._virtual = {};
    }
    virtualChild._virtual.parent = parent;
}
